import React, { useState, useContext } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import Context from "../../Context";

const RazonaClini = () => {
  const { showIcons } = useContext(Context);

  /* Handle functions Local Storage */
  const setLS = (nameValue, value) => {
    localStorage.setItem(nameValue, JSON.stringify(value));
  };
  const getLS = (nameValue) => {
    JSON.parse(localStorage.getItem(nameValue));
  };

  const clearLS = (nameValue) => {
    localStorage.removeItem(nameValue);
  };

  const cadenasList = [
    { value: "Apertura", label: "Apertura" },
    { value: "Cierre", label: "Cierre" },
    { value: "Extensión", label: "Extensión" },
    { value: "Flexión", label: "Flexión" },
    { value: "Inspiración", label: "Inspiración" },
    { value: "Espiración", label: "Espiración" },
  ];

  const pdasList = [
    { value: "Temporal IZQ", label: "Temporal IZQ" },
    { value: "Temporal DER", label: "Temporal DER" },
    { value: "Occipital", label: "Occipital" },

    /* Torax */
    { value: "Acromio-Clavicular IZQ", label: "Acromio-Clavicular IZQ" },
    { value: "Acromio-Clavicular DER", label: "Acromio-Clavicular DER" },
    { value: "Esternón", label: "Esternón" },
    /* Pelvis */
    { value: "Ilíaco IZQ", label: "Ilíaco IZQ" },
    { value: "Ilíaco DER", label: "Ilíaco DER" },
    { value: "Sacro", label: "Sacro" },
    /* Pie */
    { value: "Escafo-Cuboides IZQ", label: "Escafo-Cuboides IZQ" },
    { value: "Escafo-Cuboides DER", label: "Escafo-Cuboides DER" },
    { value: "Calcáneo", label: "Calcáneo" },
  ];

  const localSintoma = JSON.parse(localStorage.getItem("localSintoma"));
  /* const localSintoma = getLS("localSintoma"); */
  const [sintoma, setSintoma] = useState(localSintoma);

  const localPda = JSON.parse(localStorage.getItem("localPda"));
  const [pda, setPda] = useState(localPda);

  const localCadenaCausal = JSON.parse(
    localStorage.getItem("localCadenaCausal")
  );
  const [cadenaCausal, setCadenaCausal] = useState(localCadenaCausal);

  const localCadenaReactiva = JSON.parse(
    localStorage.getItem("localCadenaReactiva")
  );
  const [cadenaReactiva, setCadenaReactiva] = useState(localCadenaReactiva);

  const handleSintomaChange = (event) => {
    setSintoma(event.target.value);
    setLS("localSintoma", event.target.value);
    /* console.log('value', event.target.value) */
  };

  // handle change event of the pda++ dropdown
  const handlePdasChange = (value) => {
    setPda(value);
    setLS("localPda", value);
  };
  // handle change event of the cadena dropdown
  const handleCadenaCausalChange = (value) => {
    setCadenaCausal(value);
    setLS("localCadenaCausal", value);
  };

  const handleCadenaReactivaChange = (value) => {
    setCadenaReactiva(value);
    setLS("localCadenaReactiva", value);
  };

  const handleDeleteAll = () => {
    setSintoma("");
    setPda("");
    setCadenaCausal("");
    setCadenaReactiva("");

    clearLS(
      "localSintoma",
      "localPda",
      "localCadenaCausal",
      "localCadenaReactiva"
    );
  };
  return (
    <>
      <div className="column">
        <div className="card-section">
          <div style={{ margin: 20 }}>
            <h4 className="text-center">Razonamiento Clínico</h4>
            <br />
            <h6>Síntoma</h6>
            <Form.Control
              as="textarea"
              placeholder="Síntoma principal"
              value={sintoma}
              onChange={handleSintomaChange}
            />
            <br />
            <h6>PdA++</h6>
            <Select
              className="react-select__option"
              placeholder="Seleccione el PdA++"
              value={pda}
              options={pdasList}
              onChange={handlePdasChange}
            />
            <br />
            <h6>Cadena Causal</h6>
            <Select
              className="react-select__option"
              placeholder="Seleccione la Cadena"
              value={cadenaCausal}
              /* isMulti */
              options={cadenasList}
              onChange={handleCadenaCausalChange}
            />
            <br />
            <h6>Cadena Reactiva</h6>
            <Select
              className="react-select__option"
              placeholder="Seleccione la Cadena"
              value={cadenaReactiva}
              options={cadenasList}
              onChange={handleCadenaReactivaChange}
            />
          </div>
        </div>
        {showIcons && (
          <div className="icons-card-canvas mb-5">
            <img
              className="icon-trash-canvas"
              src="/assets/images/trash.png"
              alt="icon-image"
              onClick={handleDeleteAll}
            />
            {/* <img
            className="icon-trash-canvas"
            src="/assets/images/icon-download.png"
            alt="icon-image"
            onClick={() => alert("Imagen guardada")}
          /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default RazonaClini;
